import React, { useState, useEffect } from 'react';
import NavigationBar from "../components/NavigationBar";
import addTreeCss from '../styles/addtree.module.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from "../config/api";

const AddTree = () => {
  const [treeData, setTreeData] = useState([]);
  const [selectedSpeciesId, setSelectedSpeciesId] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('Bearing');
  const [planterName, setPlanterName] = useState('');
  const [treePlantedById, setTreePlantedById] = useState('');
  const [longitude, setLongitude] = useState('');
  const [latitude, setLatitude] = useState('');
  const [dateAdded, setDateAdded] = useState('');
  const [pinVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTreeData = async () => {
        try{
            const response = await fetch(`${API_URL}/public/trees/get_tree_list.php`
            );
            const result = await response.json();
            if(result.success){
                setTreeData(result.data);
            }
        }catch(err){
            console.error(err);
        }
    };
    fetchTreeData();
  }, []);

  const isValidLongitude = (longitude) => {
    return !isNaN(parseFloat(longitude)) && isFinite(longitude) && longitude >= -180 && longitude <= 180;
  };

  const isValidLatitude = (latitude) => {
    return !isNaN(parseFloat(latitude)) && isFinite(latitude) && latitude >= -90 && latitude <= 90;
  };


  const handleSubmit = async (event) => {
      event.preventDefault();
      setIsLoading(true);
      setError("");
      if (!isValidLongitude(longitude) || !isValidLatitude(latitude)) {
          toast.error("Invalid longitude or latitude.");
          setIsLoading(false);
          return;
      }
      try {
          const response = await fetch(`${API_URL}/public/trees/add_tree_pin.php`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                      speciesid: selectedSpeciesId,
                      status: selectedStatus,
                      plantername: planterName,
                      treeplantedbyid: treePlantedById,
                      longitude: parseFloat(longitude),
                      latitude: parseFloat(latitude),
                      dateadded: dateAdded
                  })
              }
          );
          const result = await response.json();
          if (result.success) {
              toast.success(
                  "New tree pin added successfully. Wait for Admin verification."
              );
              setSelectedSpeciesId("");
              setSelectedStatus("Bearing");
              setPlanterName("");
              setLongitude("");
              setLatitude("");
              setDateAdded("");
              setTreePlantedById("");
          } else {
              toast.error(result.message);
          }
      } catch (err) {
          console.error(err);
          toast.error("Failed to add tree.");
      } finally {
          setIsLoading(false);
      }
  };


  return (
    <>
      <NavigationBar />
      <div className={addTreeCss.container}>
        <div className={addTreeCss.card3}>
          <h1 className={addTreeCss.addtree}>Add Tree</h1>
          <form onSubmit={handleSubmit}>
            <div className={addTreeCss['form-row']}>
              <div className="col-md-6">
                <div className={addTreeCss.formGroup}>
                  <label htmlFor="inputSpecies">Choose Species</label>
                  <select
                    id="inputSpecies"
                    className="form-control"
                  >
                    <option value="">Choose...</option>
                    <option value="FIT">Indigenous Fruit Tree</option>
                    <option value="FST  ">Indigenous Forest Tree</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className={addTreeCss.formGroup}>
                  <label htmlFor="inputStatus">Choose Status</label>
                  <select
                    id="inputStatus"
                    className="form-control"
                    value={selectedStatus}
                    onChange={e => setSelectedStatus(e.target.value)}
                  >
                    <option value="Bearing">Bearing</option>
                    <option value="Flowering">Flowering</option>
                    <option value="Growing">Growing</option>
                    <option value="Matured">Matured</option>
                    <option value="Infected">Infected</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
              <div className={addTreeCss.formGroup}>
              <label for="inputTreeName">Name of Tree</label>
              <select id="inputTreeName" className={addTreeCss['form-control']}
                value={selectedSpeciesId}
                onChange={e => setSelectedSpeciesId(e.target.value)}
              >
                <option value="">Choose...</option>
                {treeData.map((species) => (
                  <option key={species.speciesid} value={species.speciesid}>
                    {species.name}
                  </option>
                ))}
              </select>
              </div></div>
              <div className="col-md-6">
                <div className={addTreeCss.formGroup}>
                  <label htmlFor="inputPlanterName">Name of Planter</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputPlanterName"
                    value={planterName}
                    onChange={e => setPlanterName(e.target.value)}
                    placeholder="Name of the planter"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className={addTreeCss.formGroup}>
                    <label htmlFor="inputTreePlantedById">
                        Planted By ID
                    </label>

                    <input
                        type="text"
                        className="form-control"
                        id="inputTreePlantedById"
                        value={treePlantedById}
                        onChange={(e) => setTreePlantedById(e.target.value)}
                        placeholder="Enter Planted By ID"
                    />
                </div>
            </div>
              <div
                  style={{
                      display: "flex",
                      gap: "5px",
                      width: "90%",
                      marginTop: "20px",
                      marginLeft: "20px"
                  }}
              >
                  <div style={{ flex: 1 }}>
                      <div className={addTreeCss.formGroup}>
                          <label htmlFor="inputLongitude">Longitude</label>
                          <input
                              type="number"
                              step="0.000001"
                              className="form-control"
                              id="inputLongitude"
                              value={longitude}
                              onChange={e => setLongitude(e.target.value)}
                              placeholder="Longitude"
                          />
                      </div>
                  </div>

                  <div style={{ flex: 1 }}>
                      <div className={addTreeCss.formGroup}>
                          <label htmlFor="inputLatitude">Latitude</label>
                          <input
                              type="number"
                              step="0.000001"
                              className="form-control"
                              id="inputLatitude"
                              value={latitude}
                              onChange={e => setLatitude(e.target.value)}
                              placeholder="Latitude"
                          />
                      </div>
                  </div>

                  <div style={{ flex: 1 }}>
                      <div className={addTreeCss.formGroup}>
                          <label htmlFor="inputDateAdded">Date Added</label>
                          <input
                              type="datetime-local"
                              className="form-control"
                              id="inputDateAdded"
                              value={dateAdded}
                              onChange={e => setDateAdded(e.target.value)}
                          />
                      </div>
                  </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className={addTreeCss.btn} disabled={isLoading}>Submit</button>
            </div>
            {error && <p className="error">{error}</p>}
            {/* ToastContainer for displaying Toast notifications */}
            <ToastContainer position="top-center" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </form>
        </div>
      </div>

    </>
  );
};

export default AddTree;
